import React, { useState } from "react"
import { Container, Row, Col, Button } from "reactstrap"
import AttributeSelect from "./AttributeSelect"

const Family = () => {
  const [motherFur, setMotherFur] = useState({})
  const [fatherFur, setFatherFur] = useState({})
  const [motherEyes, setMotherEyes] = useState({})
  const [fatherEyes, setFatherEyes] = useState({})
  const [motherCoat, setMotherCoat] = useState({})
  const [fatherCoat, setFatherCoat] = useState({})
  const [motherColoring, setMotherColoring] = useState({})
  const [fatherColoring, setFatherColoring] = useState({})
  const [motherWhite, setMotherWhite] = useState({})
  const [fatherWhite, setFatherWhite] = useState({})
  const [numOfKits, setNumOfKits] = useState(0)
  const [kittens, setKittens] = useState([])
  
  const furColors = [
    { label: 'Black', value: 'Bl' },
    { label: 'Grey', value: 'Gy' },
    { label: 'Brown', value: 'Br' },
    { label: 'Red', value: 'Re' },
    { label: 'White', value: 'Wh' },
    { label: 'Calico', value: 'Ca' }
  ];
  
  const eyeColors = [
    { label: 'Amber', value: 'Am' },
    { label: 'Green', value: 'Gr' },
    { label: 'Brown', value: 'Br' },
    { label: 'Blue', value: 'Bl' }
  ];
  
  const coats = [
    { label: 'Shorthair', value: 'Sh' },
    { label: 'Longhair', value: 'Lh' },
  ]
  
  const colorings = [
    { label: 'Solid', value: 'solid' },
    { label: 'Tabby', value: 'tabby' }
  ]
  
  const whiteSpottings = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ]
  
  const generateAttribute = chance => Math.floor(Math.random() * chance)
  const generateDeafness = () => Math.floor(Math.random() * 4) + 1 // 25% chance of deafness for solid white blue eyes
  const generateCalico = sex => {
    let possibilities
    if (sex === "Female") {
      possibilities = ["Red", "Black", "Calico"]
      const pickOne = possibilities[generateAttribute(3)]
      return pickOne
    }
    else {
      possibilities = ["Red", "Black"]
      const pickOne = possibilities[generateAttribute(2)]
      return pickOne
    }
  }
  const generateColor = (motherColor, fatherColor, sex, whiteSpotting) => {
    const isCalicoOrTortoiseshell = (color, whiteSpotting) => {
      if (color === "Calico") {
        return whiteSpotting ? "Calico" : "Tortoiseshell"
      } else {
        return color
      }
    }

    if ((motherColor === "Red" && fatherColor === "Black") || (motherColor === "Black" && fatherColor === "Red")) {
      return isCalicoOrTortoiseshell(generateCalico(sex), whiteSpotting)
    } else if (motherColor === "Calico" && (fatherColor === "Black" || fatherColor === "Red")) {
      return isCalicoOrTortoiseshell(generateCalico(sex), whiteSpotting)
    } else {
      return generateAttribute(2) === 0 ? motherColor : fatherColor
    }
  }
  
  const generateLitter = () => {
    const litterSize = Math.floor(Math.random() * 4) + 1
    console.log("litterSize", litterSize)
    const emptyLitter = new Array(litterSize).fill({})
    const litter = [...emptyLitter].map((kitten, index) => {
      const eyes = generateAttribute(2) === 0 ? motherEyes.label : fatherEyes.label
      const coat = generateAttribute(2) === 0 ? motherCoat.label : fatherCoat.label
      const sex = generateAttribute(2) === 0 ? "Male" : "Female"
      const whiteSpotting = generateAttribute(2) === 0 ? motherWhite.value : fatherWhite.value
      const fur = generateColor(motherFur.label, fatherFur.label, sex, whiteSpotting)
      const coloring = generateAttribute(2) === 0 ? motherColoring.label : fatherColoring.label
      const isDeaf = fur === "White" && eyes === "Blue" && coloring === "Solid" ? (generateDeafness() > 3 ? true : false) : false
      return { fur, eyes, coat, sex, coloring, isDeaf, whiteSpotting }
    })
    setNumOfKits(litterSize)
    setKittens(litter)
    console.log("final should  have kittens", litter)
  }
  
  const isButtonDisabled = !motherFur.label || !fatherFur.label || !motherEyes.label || !fatherEyes.label || !motherCoat.label || !fatherCoat.label || !motherColoring.label || !fatherColoring.label || !motherWhite.label || !fatherWhite.label
  
  return (<Container>
    <Row>
      <Col xs={12} sm={6} className="mother">
        <h2>Mother</h2>
        <AttributeSelect label="Pelt Pattern" setParentAttribute={setMotherColoring} options={colorings}/>
        <AttributeSelect label="Fur" setParentAttribute={setMotherFur} options={furColors} />
        <AttributeSelect label="Eyes" setParentAttribute={setMotherEyes} options={eyeColors}/>
        <AttributeSelect label="Coat Length" setParentAttribute={setMotherCoat} options={coats}/>
        <AttributeSelect label="White Spotting" setParentAttribute={setMotherWhite} options={whiteSpottings}/>
      </Col>
      <Col xs={12} sm={6}>
        <h2>Father</h2>
        <AttributeSelect label="Pelt Pattern" setParentAttribute={setFatherColoring} options={colorings}/>
        <AttributeSelect label="Fur" setParentAttribute={setFatherFur} options={furColors} />
        <AttributeSelect label="Eyes" setParentAttribute={setFatherEyes} options={eyeColors}/>
        <AttributeSelect label="Coat Length" setParentAttribute={setFatherCoat} options={coats}/>
        <AttributeSelect label="White Spotting" setParentAttribute={setFatherWhite} options={whiteSpottings}/>
      </Col>
    </Row>
    <Row>
      <Col className="text-center">
        <br/>
        <Button color="primary" onClick={() => generateLitter()} disabled={isButtonDisabled}>Roll for kits</Button>
      </Col>
    </Row>
    {numOfKits ? (<Row className="d-block"><h2 className="h4 kitten-number">{numOfKits > 1 ? `${numOfKits} kittens` : `${numOfKits} kitten`}</h2></Row>) : null}
    <Row className="kittens">
      {kittens.map((kitten, index) => (
        <Col xs={12} sm={6} lg={4} xl={3} className="text-center" key={`kitten-${index+1}`}>
        <h3 className="h5">
          {`Kitten #${index +1}`}
        </h3>
        <div>{`${kitten.fur} fur`}</div>
        <div>{`${kitten.eyes} eyes`}</div>
        <div>{`${kitten.coat}`}</div>
        <div>{`${kitten.coloring} coloration`}</div>
        {kitten.fur !== "Calico" && kitten.fur !== "Tortoiseshell" && kitten.whiteSpotting && (<div>White spotting</div>)}
        <div>{kitten.sex}</div>
        {kitten.isDeaf && <div>Deaf</div>}
      </Col>))}
    </Row>
  </Container>)
}

export default Family